import * as React from 'react';
import { useIntl } from 'react-intl';

import { Text, ButtonModel } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import { useShadefinderTransitions } from '../../hooks/useShadefinderTransitions';
import { messages } from '../../messages';
import { trackShadefinderBack } from '../../tracking';
import { StepContainer } from '../StepContainer';
import {
  ImageCircle,
  FullWidthWrapper,
  ChooseShadeButton,
  PaddingWrapper,
  HowWeChooseShadesContent,
  HowWeChooseShadesImageWrapper,
} from '../styled';

export const HowWeChooseShades: React.FC<{ timeOfStart: number }> = ({
  timeOfStart,
}) => {
  const { formatMessage } = useIntl();
  const { getTimeFromInit, getVariant } = useTrackingContext();
  const { back } = useShadefinderTransitions();

  return (
    <StepContainer
      unmounting={false}
      header={formatMessage(messages.howWeChooseShadesTitle)}
      subheader={formatMessage(messages.howWeChooseShadesDescription)}
      horizontalScroll={false}
    >
      <div>
        <FullWidthWrapper>
          <HowWeChooseShadesImageWrapper>
            <ImageCircle src="https://cdn.notinoimg.com/images/gallery/ux/shade-finder-v2/photo_shades.jpg" />
          </HowWeChooseShadesImageWrapper>
          <HowWeChooseShadesContent>
            <Text
              typography="labelLarge"
              paddingBottom="0.5rem"
              block={true}
              color="text.primary"
            >
              {formatMessage(messages.howWeChooseShadesStep1Title)}
            </Text>

            <Text typography="bodyRegular" paddingBottom="2rem" block={true}>
              {formatMessage(messages.howWeChooseShadesStep1Description)}
            </Text>

            <Text
              typography="labelLarge"
              paddingBottom="0.5rem"
              block={true}
              color="text.primary"
            >
              {formatMessage(messages.howWeChooseShadesStep2Title)}
            </Text>

            <Text typography="bodyRegular" paddingBottom="2rem" block={true}>
              {formatMessage(messages.howWeChooseShadesStep2Description)}
            </Text>

            <Text
              typography="labelLarge"
              paddingBottom="0.5rem"
              block={true}
              color="text.primary"
            >
              {formatMessage(messages.howWeChooseShadesStep3Title)}
            </Text>

            <Text typography="bodyRegular" block={true}>
              {formatMessage(messages.howWeChooseShadesStep3Description)}
            </Text>
          </HowWeChooseShadesContent>
        </FullWidthWrapper>

        <PaddingWrapper>
          <ChooseShadeButton
            onClick={() => {
              back();
              trackShadefinderBack({
                variant: getVariant(),
                timing: getTimeFromInit(timeOfStart),
                name: 'how_we_select_back',
              });
            }}
            buttonStyle={ButtonModel.Styles.primary}
          >
            {formatMessage(messages.iWantToChooseShade)}
          </ChooseShadeButton>
        </PaddingWrapper>
      </div>
    </StepContainer>
  );
};
